<template>
  <b-container fluid>
    <div class="row">
      <template v-if="loading">
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="card" style="width: 100%">
          <div class="card-header">
            <h6 class="mb-0">
              <strong>EQUIPAMENTOS</strong>
            </h6>
          </div>
          <div class="card-body">
            <b-table
              show-empty
              @row-selected="onRowSelected"
              selectable
              select-mode="single"
              stacked="sm"
              striped
              emptyText="Não existem equipamentos associados a este cliente"
              :borderless="true"
              :items="displayItens"
              :fields="fields"
              :per-page="perPage"
              :filter="filter"
            >
             <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
         
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          
        </template>
      </template>
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="goToEdit(row.item.idDevice)">
                  <i class="fe fe-edit"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>

        <div v-if="selectedRowKeys.length> 0" class="card" style="width: 100%">
          <div class="card-header">
            <h6 class="mb-0">
              <strong>CONTRATO</strong>
              
            </h6>
           
          </div>
          <div class="card-body">
            <a-form layout="vertical" >
              <div class="row">
                <div class="col-md-3">
                  <a-form-item label="Tipo de Contrato:">
                    <a-select v-model="filtrosLocal.contractType">
                      <a-select-option value>Selecione</a-select-option>
                      <a-select-option value="1" key="1">Aluguel</a-select-option>

                      <a-select-option value="2" key="2">Venda</a-select-option>
                      <a-select-option value="3" key="3">Seguro</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </div>
              <div v-if="filtrosLocal.contractType == 1">
                <div class="row">
                  <div class="col-md-2">
                    <ValidationProvider rules="required" :name="`aluguel${_uid}`">
                      <b-form-group label="Aluguel" slot-scope="{ valid, errors }">
                        <b-input
                          placeholder="Aluguel"
                          v-model.lazy="form.deviceRentFee"
                          v-money="money"
                          :name="`aluguel${_uid}`"
                          :state="errors[0] ? false : valid ? true : null"
                        />
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-3">
                    <ValidationProvider rules="required" :name="`aluguelpromocional${_uid}`">
                      <b-form-group label="Aluguel Promocional" slot-scope="{ valid, errors }">
                        <b-input
                          placeholder="Aluguel Promocional"
                          v-model.lazy="form.deviceRentPromotionalFee"
                          v-money="money"
                          :name="`aluguelpromocional${_uid}`"
                          :state="errors[0] ? false : valid ? true : null"
                        />
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-3">
                    <b-form-group label="Validade Promoção">
                      <!-- :disabled="!form.fgDeviceRent"
                      style="width: 100%"-->
                      <b-form-datepicker
                        placeholder="Validade Promoção"
                       
                        v-model.lazy="form.deviceRentPromotionExpireDate"
                        locale="pt-BR"
                        :start-weekday="0"
                        :hide-header="true"
                        :show-decade-nav="false"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <b-form-group label>
                      <!-- :disabled="!form.fgDeviceRent"
                      style="width: 100%"-->
                      <b-form-checkbox
                        id="checkbox-1"
                        name="checkbox-1"
                        value="true"
                        unchecked-value="false"
                        size="lg"
                        v-model="form.fgDeviceRentFeeByTpv"
                      >Tem Isenção de por TPV?</b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label>
                      <!-- :disabled="!form.fgDeviceRent"
                      style="width: 100%"-->
                      <b-input
                        placeholder="Aluguel"
                        v-model.lazy="form.deviceRentFeeByTpv"
                        v-money="money"
                        :name="`aluguel${_uid}`"
                        :disable="!form.fgDeviceRentFeeByTpv"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div v-if="filtrosLocal.contractType == 2">
                <div class="row">
                  <div class="col-md-3">
                    <ValidationProvider rules="required" :name="`parcela${_uid}`">
                      <b-form-group label="Valor Parcela" slot-scope="{ valid, errors }">
                        <b-input
                          placeholder="Valor parcela"
                          v-model.lazy="form.deviceParcelAmount"
                          v-money="money"
                          :name="`parcela${_uid}`"
                          :state="errors[0] ? false : valid ? true : null"
                        />
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-3">
                    <ValidationProvider rules="required" :name="`parcela_qtd${_uid}`">
                      <b-form-group label="Parcelas" slot-scope="{ valid, errors }">
                        <b-select v-model="form.parcels" ref="parcels">
                          <b-select-option :value="null">Selecione</b-select-option>
                          <b-select-option
                            :value="index + 1"
                            v-for="(item, index) in parcels"
                            :key="`parcels-${index}`"
                            required
                          >{{ item }}</b-select-option>
                        </b-select>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="row">
      <div class="col-xl">
        <b-btn
         @click="saveContractType"
          class="col-md-2"
          variant="outline-primary"
          :disabled="loadingContractType"
          >Salvar 
          <b-spinner
            small
            variant="primary"
            label="Spinning"
            v-show="loadingContractType"
          ></b-spinner>
        </b-btn>
      </div>
    </div>
            </a-form>
          </div>
        </div>
      </template>
    </div>
  </b-container>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import moment from "moment";
import { VMoney } from "v-money";
import { EquipamentosResource } from "@/resources/Equipamentos.resource.js";
import {DeviceContractResource} from "@/resources/DeviceContract.resource.js";


export default {
  props: {
    idMerchant: {
      type: String,
      default: () => 0
    }
  },
  directives: { money: VMoney },
  data() {
    return {
      readOnly: false,
      loading: false,
      loadingContractType: false,
      deviceContract: {},
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: true
      },
      filtrosLocal: {
        idMerchant: this.idMerchant,
        index: 1,
        size: 100,
        contractType: "1"
      },
      form: {
        serialNumber: "",
        logicNumber: "",
        amount: 0,
        parcel: 1,
        deviceRentFee: 0,
        deviceParcelAmount: 0,
        
        fgDeviceRent: false,
        deviceRentPromotionExpireDate: null,
        deviceRentPromotionalFee: 0,
        fgDeviceRentFeeByTpv: "false",
        deviceRentFeeByTpv: 0
      },
      itens: [],
      selectedRowKeys: [],
      displayItens: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      parcels: [
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x",
        "11x",
        "12x"
      ],
      pageOptions: [25, 40, 60],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {key:'selected', label: "*"},
        {
          key: "idDevice",
          label: "#"
        },
        {
          key: "serialNumber",
          label: "Serial"
        },
        {
          key: "logicNumber",
          label: "Numero Lógico	"
        },
        {
          key: "deviceStatusName",
          label: "Status"
        },
        {
          key: "deviceModelName",
          label: "Modelo"
        },
        {
          key: "salesMan",
          label: "Representante"
        },
        {
          key:"idDeviceContract",
          label:"Contrato Equip."

        },
        { key: "actions", label: "Editar" }
      ]
    };
  },
  
   computed: {
    GetSn(){
      if(this.selectedRowKeys == null || this.selectedRowKeys.length ==0) return '';
        var sns =   this.selectedRowKeys.reduce((result, atual) => { return (result +=   atual.serialNumber); });
        return sns;
    },
     GetIdDevice(){
      if(this.selectedRowKeys == null || this.selectedRowKeys.length ==0) return 0;
        var sns =   this.selectedRowKeys.reduce((result, atual) => { return (result +=   atual.idDevice); });
        return parseInt(sns.idDevice);
    },
      GetIdDeviceContract(){
      if(this.selectedRowKeys == null || this.selectedRowKeys.length ==0) return 0;
        var sns =   this.selectedRowKeys.reduce((result, atual) => { return (result +=   atual.idDeviceContract); });
       
        return isNaN(parseInt(sns.idDeviceContract)) ? 0  : parseInt(sns.idDeviceContract)  ;
    }
   
  },
  methods: {
    moment,
     onRowSelected(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      let idDeviceContract = this.GetIdDeviceContract;
      if(idDeviceContract > 0)
      {
         this.loadDeviceContract(this.GetIdDevice);
      }
      else{
        this.cleanDeviceContract();

      }
    },
    search() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        this.loading = true;
        EquipamentosResource.getLista(this.filtrosLocal)
          .then(result => {
            try {
              this.itens = result.data.payload.items;
              this.displayItens = this.itens.flat();
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {
            // Surpress
            this.loading = false;
          });
      } else {
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },


    cleanDeviceContract()
    {
              this.form.deviceRentFee  =0;
              this.form.deviceRentFeeByTpv =0;
              this.form.fgDeviceRentFeeByTpv = "false";
              this.form.deviceRentPromotionExpireDate = ""  
              this.form.deviceRentPromotionalFee = 0;
              this.form.deviceSellParcelAmount =  0;    
    },

    loadDeviceContract(idDevice){

      DeviceContractResource.getDetail({idDevice :idDevice })
      .then(result => {
         try {
              this.form.deviceRentFee  = parseFloat(result.data.payload.rentFee).toFixed(2);
              this.form.deviceRentFeeByTpv = parseFloat(result.data.payload.tpvValue).toFixed(2);
              this.form.fgDeviceRentFeeByTpv = result.data.payload.fgRFreeRentByTpv.toString();
              this.form.deviceRentPromotionExpireDate = result.data.payload.rentPromotionalExpireDate;   
              this.form.deviceRentPromotionalFee = parseFloat(result.data.payload.rentPromotionalFee).toFixed(2);
              this.form.deviceSellParcelAmount =   parseFloat(result.data.payload.amount).toFixed(2);         
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
      })
      .catch(e => {
            // Surpress
            this.loading = false;
      });


    },
    //TODO mover isso para uma lib de utils
     unmaskMoney(value) {
      
       let result = parseInt(
          (value + "")
            .replace(/R\$/gi, "")
            .replace(/\s/gi, "")
            .replace(/\./gi, "")
            .replace(/,/gi, "")
        ) / 100;
        return isNaN(result) ? 0 : result;
      
    },
    stringToBoolean(value){
      if( typeof value !== 'string') return value;
    switch(value.toLowerCase().trim()){
        case "true": case "yes": case "1": return true;
        case "false": case "no": case "0": case null: return false;
        default: return Boolean(value);
    }
    },

    saveContractType()
   {
      this.loadingContractType = true;
       const  deviceContractPayload = {
              idDevice: this.GetIdDevice,
              amount: this.unmaskMoney( this.form.deviceSellParcelAmount),
              parcels: this.form.parcel,
              rentFee: this.unmaskMoney(this.form.deviceRentFee),
              rentPromotionalFee: this.unmaskMoney(this.form.deviceRentPromotionalFee),
              rentPromotionalExpireDate: 
              this.form.deviceRentPromotionExpireDate= this.form.deviceRentPromotionExpireDate == "" ? null : this.form.deviceRentPromotionExpireDate ,
              fgRFreeRentByTpv:  this.stringToBoolean (this.form.fgDeviceRentFeeByTpv),
              tpvValue: this.unmaskMoney(this.form.deviceRentFeeByTpv),
              idDeviceContractType: parseInt(this.filtrosLocal.contractType)
            };

           if(this.GetIdDeviceContract == 0)
           {
              DeviceContractResource.add(deviceContractPayload).then((result)=>{
              this.loadingContractType = false;
              this.$notification['success']({
                    message: 'Registro Salvo',
                    description: '',
                  })

                })
                .catch((e)=> {
                      this.loadingContractType = false
                }) 

           }
           else
           {
             deviceContractPayload.IdDeviceContract = this.GetIdDeviceContract;
              DeviceContractResource.update(deviceContractPayload).then((result)=>{
              this.loadingContractType = false;
              this.$notification['success']({
                    message: 'Registro Atualizado.',
                    description: '',
                  })

                })
                .catch((e)=> {
                      this.loadingContractType = false
                }) 

           }
          
         

   },

    onChangePage(a) {
      this.filtrosLocal.index = a;
      this.search();
    },
    goToEdit(id) {
      this.$router.push({
        path: `/ativos/equipamentos/${id}/edit/`
      });
    }
  },
  created() {
    this.search();
  }
};
</script>

<style lang="scss">
</style>
